module.exports = __webpack_public_path__ + "img/GS_Profile-Zinhle Situla.cec38c76.png";